import type { RequestSpec } from '@/types';

export function generatePython(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const headers: string[] = [`"Accept": "application/json"`];
  if (hasAuth) headers.push(`"Authorization": f"Bearer {ACCESS_TOKEN}"`);

  const hasBody = spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE';
  const bodyDecl = hasBody ? `\npayload = ${pyRepr(spec.body)}\n` : '';
  const callKwarg = hasBody ? ', json=payload' : '';

  return `import requests
import os

ACCESS_TOKEN = os.environ["LIBERTIFY_TOKEN"]
${bodyDecl}
response = requests.${spec.method.toLowerCase()}(
    "${url}",
    headers={
        ${headers.join(',\n        ')},
    }${callKwarg},
)
response.raise_for_status()
print(response.json())`;
}

// Convert a JS value to a Python literal (handles dict/list/str/num/bool/null).
function pyRepr(value: unknown, indent = 0): string {
  const pad = '    '.repeat(indent);
  const innerPad = '    '.repeat(indent + 1);

  if (value === null) return 'None';
  if (value === undefined) return 'None';
  if (typeof value === 'boolean') return value ? 'True' : 'False';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'string') return JSON.stringify(value);

  if (Array.isArray(value)) {
    if (value.length === 0) return '[]';
    const items = value.map((v) => `${innerPad}${pyRepr(v, indent + 1)}`).join(',\n');
    return `[\n${items},\n${pad}]`;
  }

  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>);
    if (entries.length === 0) return '{}';
    const items = entries
      .map(([k, v]) => `${innerPad}${JSON.stringify(k)}: ${pyRepr(v, indent + 1)}`)
      .join(',\n');
    return `{\n${items},\n${pad}}`;
  }

  return JSON.stringify(value);
}
